<template>
  <svg
    id="SPI"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 237.063 209.417"
  >
    <g
      id="Retângulo_32"
      data-name="Retângulo 32"
      transform="translate(0 33.417)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <rect
      id="Retângulo_33"
      data-name="Retângulo 33"
      width="95"
      height="163"
      transform="translate(99 22.417)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-file"
      data-name="Icon awesome-file"
      d="M76.019,46.154V0H8.145A8.125,8.125,0,0,0,0,8.145V165.613a8.125,8.125,0,0,0,8.145,8.145H122.173a8.125,8.125,0,0,0,8.145-8.145V54.3H84.164A8.169,8.169,0,0,1,76.019,46.154Zm54.3-4.785v2.07H86.879V0h2.07a8.139,8.139,0,0,1,5.769,2.376l33.224,33.258A8.119,8.119,0,0,1,130.318,41.369Z"
      transform="translate(106.744)"
      :fill="color"
    />
    <path
      id="Icon_awesome-retweet"
      data-name="Icon awesome-retweet"
      d="M66.492,34.2,55.841,44.847a2.539,2.539,0,0,1-3.591,0L41.6,34.2a2.539,2.539,0,0,1,0-3.591l1.145-1.145a2.539,2.539,0,0,1,3.641.052l4.275,4.527V14.773H30.82a2.539,2.539,0,0,1-1.8-.743l-1.693-1.693A2.539,2.539,0,0,1,29.128,8H54.892a2.539,2.539,0,0,1,2.539,2.539v23.5l4.276-4.527a2.539,2.539,0,0,1,3.641-.052l1.145,1.145A2.539,2.539,0,0,1,66.492,34.2ZM38.444,35.828a2.539,2.539,0,0,0-1.8-.744H16.808V15.818l4.276,4.527a2.539,2.539,0,0,0,3.641.052l1.145-1.145a2.539,2.539,0,0,0,0-3.591L15.219,5.011a2.539,2.539,0,0,0-3.591,0L.977,15.662a2.539,2.539,0,0,0,0,3.591L2.121,20.4a2.539,2.539,0,0,0,3.641-.052l4.276-4.527v23.5a2.539,2.539,0,0,0,2.539,2.539H38.341a2.539,2.539,0,0,0,1.8-4.334Z"
      transform="translate(137.767 62.15)"
      fill="#fff"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
